<template>
  <div>
      <sonicu-header>
          Alarm Summary
      </sonicu-header>
      <div class="mt-5 grid grid-cols-1 gap-5 lg:grid-cols-2">
        <div v-for="key in ['threshold', 'offline']" class="bg-white overflow-hidden shadow rounded-lg flex flex-col justify-between">
          <div class="px-4 py-5 sm:p-6">
            <div class="flex items-center">
              <div class="shrink-0 bg-blue-500 rounded-md p-3">
                <div :class="key === 'offline' ? 'lnr icon-cloud-crossed' : 'lnr icon-coolant-temperature'"
                class="text-white"></div>
              </div>
              <div class="ml-5 w-0 flex-1">
                <dl>
                  <dt class="text-base leading-6 font-normal text-gray-900">
                    {{ key === 'threshold' ? 'Threshold Alarms' : 'Offline Alarms'}}
                  </dt>
                  <dd class="mt-1 flex justify-between items-baseline md:block lg:flex">
                    <loading v-if="!loaded || !data[key]" width="w-32" height="w-8"></loading>
                    <div v-else class="flex items-baseline text-2xl leading-8 font-semibold text-blue-600">
                      {{ alarmStats(key).active }}
                      <span v-if="alarmStats(key).snoozed > 0"
                            class="ml-2 text-sm leading-5 font-medium text-gray-500">
                        with {{alarmStats(key).snoozed }} more snoozed
                      </span>
                    </div>
                    <loading v-if="!loaded || !data[key]" width="w-24" height="w-4" class="my-2"></loading>
                    <div v-else class="">
                      <!-- Add stats about alarms in the past week if we're not on mobile-->
                      <div class="hidden sm:inline">
                        <div v-if="alarmStats(key).historicallyIncreasing" class="inline-flex items-baseline px-2.5 py-0.5 rounded-full text-sm font-medium leading-5 bg-red-100 text-red-800 md:mt-2 lg:mt-0">
                          <svg class="-ml-1 mr-0.5 shrink-0 self-center h-5 w-5 text-red-500" fill="currentColor" viewBox="0 0 20 20">
                            <path fill-rule="evenodd" d="M5.293 9.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 7.414V15a1 1 0 11-2 0V7.414L6.707 9.707a1 1 0 01-1.414 0z" clip-rule="evenodd" />
                          </svg>
                          {{ alarmStats(key).historical }} in the last 7 days (up from {{ alarmStats(key).lastWeekCount }})
                        </div>
                        <div v-else-if="alarmStats(key).historical !== 0 || alarmStats(key).lastWeekCount !== 0" class="inline-flex items-baseline px-2.5 py-0.5 rounded-full text-sm font-medium leading-5 bg-green-100 text-green-800 md:mt-2 lg:mt-0">
                          <svg class="-ml-1 mr-0.5 shrink-0 self-center h-5 w-5 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                            <path fill-rule="evenodd" d="M14.707 10.293a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L9 12.586V5a1 1 0 012 0v7.586l2.293-2.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                          </svg>
                          {{ alarmStats(key).historical }} in the last 7 days (down from {{ alarmStats(key).lastWeekCount }})
                        </div>
                      </div>
                      <!-- Add an arrow if we're on mobile-->
                      <div class="inline sm:hidden shrink-0 pr-2">
                        <button
                            class="w-8 h-8 inline-flex items-center justify-center text-gray-400 rounded-full bg-transparent hover:text-gray-500 focus:outline-none focus:text-gray-500 focus:bg-gray-100">
                          <span class="lnr icon-arrow-right"></span>
                        </button>
                      </div>
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
          </div>
          <div class="hidden sm:block bg-gray-50 px-4 py-4 sm:px-6">
            <div class="text-sm leading-5">
              <a
                  :href="company.buildCompanyRoute('alarms') + '?' + (key === 'threshold' ? 'showThreshold=true&showOffline=false&showValidation=false' : 'showThreshold=false&showOffline=true&showValidation=false')"
                  class="font-medium text-blue-600 hover:text-blue-500">
                View all
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import axios from "axios";
import Loading from "@/components/elements/loading";
import SonicuHeader from "@/components/elements/SonicuHeader";


export default {

  name: "DashboardAlarmStatusSummary",
  components: {SonicuHeader, Loading},
  mixins: [SonicuCoreMixin],
  data() {
    return {
      data: {},
      loading: false,
      loaded: false,
    }
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.loading = true;
      axios.get(this.company.buildCompanyApiInternalRoute('dashboard/alarm-status-summary/')).then(
          response => {
            this.data = response.data;
            this.loading = false
            this.loaded = true;
          });
    },
    alarmStats(alarmKey){
      if(this.data[alarmKey] !== undefined){
        return this.data[alarmKey];
      }
      return null;
    }
  }
}
</script>

<style scoped>

</style>